<template>
  <div v-if="typeof id === 'undefined'" class="flex justify-center"></div>
  <NewsCategory v-else :id="id" />
</template>

<script setup lang="ts">
import { capitalize } from "vue";
import { wpCategories, wpCategoriesReverse } from "~/utils/wordpress/news";

definePageMeta({
  // Old category URLs were /en/news/category/90
  middleware: (to) => {
    if (typeof to.params.slug !== "string") {
      return;
    }

    if (to.params.slug in wpCategoriesReverse) {
      return navigateTo({
        path: `/${to.params.locale}/news/category/${
          // @ts-expect-error FUCKING RETARDED ASS TYPESCRIPT
          wpCategoriesReverse[to.params.slug]
        }`,
      });
    }
  },
});

const route = useRoute();
const slug = route.params.slug as string;

// @ts-expect-error because that's the correct type...
const id = wpCategories[slug] as string | undefined;

const nuxtApp = useNuxtApp();
const locale = nuxtApp.$i18n.global.locale;

const seo = {
  title: `${capitalize(slug)} News`,
  description: `Discover the latest ${capitalize(slug)} news on NamiComi.`,
  //slug: data.attributes.slug,
  coverUrl: "",
  href: `/en/news/category/${slug}`,
};

nuxtApp.runWithContext(() =>
  useSeoMeta({
    title: seo.title,
    ogTitle: seo.title,
    twitterTitle: seo.title,
    description: seo.description,
    ogDescription: seo.description,
    twitterDescription: seo.description,
    ogUrl: seo.href,
    ogLocale: locale.value,
    ogImage: seo.coverUrl,
    ogImageSecureUrl: seo.coverUrl,
    twitterImage: seo.coverUrl,
    //ogImageHeight: "1200",
    //ogImageWidth: "630",
    ogImageUrl: seo.coverUrl,
    //ogImageType: "image/png",
    ogImageAlt: "NamiComi",
    ogLocaleAlternate: "en_GB",
  }),
);
</script>
